/**
 * Button
 */
import Button from 'components/ui/Button';
import { useSiteType } from 'context/siteType.context';

interface ButtonModel {
	type: 'button' | 'submit' | 'reset';
	name: string;
	id: string | number;
	resetForm?: () => void;
	children: JSX.Element | JSX.Element[];
}

const FormEpiButton = ({
	type = 'button',
	name,
	id,
	resetForm,
	children,
	...propsToTransfer
}: ButtonModel) => {
	const siteType = useSiteType();
	const isLindab = siteType === 'Lindab';
	if (type === 'reset') {
		return (
			<Button
				type={type}
				name={name}
				id={id.toString()}
				{...propsToTransfer}
				onClick={resetForm}
				buttonColor="grey"
			>
				{children}
			</Button>
		);
	} else {
		return (
			<Button
				type={type}
				name={name}
				id={id.toString()}
				{...propsToTransfer}
				buttonColor={isLindab ? 'blue' : 'lgYellow'}
			>
				{children}
			</Button>
		);
	}
};

export default FormEpiButton;
